<template>
  <div>
    <AdminBreadCrumb title="メニュー管理" />
    <v-btn @click="openCreateModal" color="primary">追加申請</v-btn>
    <SearchBarWithCheckbox
      :keyword="filterKeyword"
      :checkbox="showNewItem"
      :search-result="searchResult"
      @inputKeyword="filterKeyword = $event"
      @inputCheckbox="showNewItem = $event"
      @pagination="$emit('pagination', { filterKeyword, pageNo: $event })"
      @search="$emit('search', $event)"
      class="mt-2"
      placeholder="メニュー名"
    />
    <v-card>
      <v-data-table :headers="headers" :items="itemList" hide-actions>
        <template slot="items" slot-scope="props">
          <tr style="border-bottom: 1px solid rgba(0,0,0,.02) !important;">
            <td class="text-xs-left pr-1">
              <v-switch
                v-if="props.item.canChangeRequest"
                v-model="props.item.isStatusActive"
                @click.prevent.stop="openConfirmModal(props.item)"
                class="mt-3"
              />
            </td>
            <td class="text-xs-left px-1">
              <v-btn
                v-if="props.item.canChangeRequest"
                @click="openEditModal(props.item)"
                icon
                small
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </td>
            <td class="text-xs-left no-wrap px-2">
              <span :class="{ disabled: props.item.showGreyRecord }">{{
                props.item.displayData.name
              }}</span>
            </td>
            <td class="text-xs-left no-wrap px-2">
              <span :class="{ disabled: props.item.showGreyRecord }">{{
                props.item.displayData.unitTypeUpperCase
              }}</span>
            </td>
            <td class="text-xs-left no-wrap px-2">
              <AppCurrency
                :value="props.item.displayData.unitPrice"
                :class="{ disabled: props.item.showGreyRecord }"
              />
            </td>
            <td class="text-xs-left no-wrap px-2">
              <v-chip
                :color="createChipColor(props.item.resourceType)"
                :class="{ disabled: props.item.showGreyRecord }"
                outline
                disabled
                text-color="black"
                >{{ props.item.displayData.resourceTypeString }}</v-chip
              >
              <span :class="{ disabled: props.item.showGreyRecord }">{{
                props.item.displayData.resourceName
              }}</span>
            </td>
            <td class="text-xs-left no-wrap px-2">
              <span :class="{ disabled: props.item.showGreyRecord }">{{
                props.item.displayData.dateRange
              }}</span>
            </td>
            <td class="text-xs-left no-wrap px-2">
              <div v-if="props.item.hasLatestRequest">
                <RequestDescription
                  :status="props.item.latestRequest.requestStatus"
                  :type="props.item.requestType"
                  :class="{ disabled: props.item.showGreyRecord }"
                  @click="openLatestRequestDetailModal(props.item)"
                />
              </div>
            </td>
            <td class="text-xs-left px-1">
              <v-btn @click="openDetailModal(props.item)" small class="mx-0"
                >詳細</v-btn
              >
            </td>
          </tr>
          <tr>
            <td colspan="9">
              <span
                :class="props.item.showGreyRecord ? 'disabled' : 'description'"
                class="pl-4"
                >{{ props.item.displayData.description }}</span
              >
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <div>登録されているメニューはありません</div>
        </template>
      </v-data-table>
    </v-card>
    <ModalCreate
      v-model="isActiveCreateModal"
      :searching="searching"
      :advertiser-list="advertiserList"
      :insertion-order-list="insertionOrderList"
      :system-owner="systemOwner"
      @searchAdvertiser="$emit('searchAdvertiser', $event)"
      @searchInsertionOrder="$emit('searchInsertionOrder', $event)"
      @save="onEditRequest"
    />
    <ModalEdit
      v-model="isActiveEditModal"
      :item="currentItem"
      :loading="false"
      @save="onEditRequest"
    />
    <ModalDetail
      v-model="isActiveDetailModal"
      :item="currentItem"
      @cancelRequest="cancelRequest"
    />
    <ModalDetailRequest
      v-model="isActiveLatestRequestModal"
      :item="currentItem"
    />
  </div>
</template>

<script>
import RequestDescription from '../../Shared/Presentation/Request/RequestDescription.vue'
import AdminBreadCrumb from '../../Shared/BreadCrumb/AdminBreadCrumb.vue'
import JAPANESE from '@/constants/japanese'
import ModalCreate from './ModalCreate'
import ModalEdit from './ModalEdit'
import ModalDetail from './ModalDetail'
import ModalDetailRequest from './ModalDetailRequest'
import SearchBarWithCheckbox from '@/components/Shared/Search/SearchBarWithCheckbox'
import { MenuRequestRepository } from '@/models/MenuRequest'

export default {
  components: {
    ModalCreate,
    ModalEdit,
    ModalDetail,
    AdminBreadCrumb,
    RequestDescription,
    ModalDetailRequest,
    SearchBarWithCheckbox,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    searching: {
      type: Boolean,
      default: false,
    },
    searchResult: {
      type: Object,
      default: () => {},
    },
    advertiserList: {
      type: Array,
      default: () => [],
    },
    insertionOrderList: {
      type: Array,
      default: () => [],
    },
    systemOwner: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'ステータス', value: 'status', sortable: false, class: 'pr-1' },
        {
          text: '変更申請',
          value: 'changeRequest',
          sortable: false,
          class: 'px-1',
        },
        { text: JAPANESE.menuName, value: 'name', class: 'px-2' },
        { text: JAPANESE.unitType, value: 'unitType', class: 'px-2' },
        { text: JAPANESE.unitPrice, value: 'unitPrice', class: 'px-2' },
        { text: JAPANESE.resourceType, value: 'resource', class: 'px-2' },
        { text: JAPANESE.resourceDateRange, value: 'dateRange', class: 'px-2' },
        { text: '備考', sortable: false, class: 'px-2' },
        { text: '詳細', value: 'requestStatus', class: 'px-1' },
      ],
      isActiveCreateModal: false,
      isActiveEditModal: false,
      isActiveDetailModal: false,
      isActiveLatestRequestModal: false,
      currentItem: undefined,
      showNewItem: false,
      filterKeyword: '',
    }
  },
  computed: {
    confirmModalMessage() {
      const targetName = this.currentItem.name
      const changeTo = this.currentItem.isStatusActive ? '無効' : '有効'
      return targetName + 'を' + changeTo + `に切り替えます。\nよろしいですか？`
    },
    itemList() {
      return this.searchResult.items.filter(
        item => !item.isNew || this.showNewItem,
      )
    },
  },
  methods: {
    createChipColor(type) {
      let result = ''
      switch (type) {
        case 'advertiser':
          result = 'pink'
          break
        case 'oem':
          result = 'success'
          break
        case 'agency':
          result = 'orange'
          break
        case 'insertion_order':
          result = 'primary'
          break
      }
      return result
    },
    async openConfirmModal(item) {
      this.currentItem = item
      const result = await this.$confirm(undefined, {
        body: this.confirmModalMessage,
      })
      if (result) {
        const to = item.isStatusActive ? 'inactive' : 'active'
        await item.edit({
          name: item.name,
          description: item.description,
          status: to,
        })
      }
    },
    openEditModal(item) {
      this.currentItem = item
      this.isActiveEditModal = true
    },
    openCreateModal() {
      this.isActiveCreateModal = true
    },
    openDetailModal(item) {
      this.currentItem = item
      this.isActiveDetailModal = true
    },
    openLatestRequestDetailModal(item) {
      this.currentItem = item
      this.isActiveLatestRequestModal = true
    },
    onEditRequest() {
      this.isActiveEditModal = false
      this.isActiveCreateModal = false
      this.$emit('search', this.filterKeyword)
      //this.$emit('reload')
    },
    async cancelRequest(id) {
      try {
        await MenuRequestRepository.cancelRequest(id)
      } catch (e) {
        console.error(e)
        throw e
      }
    },
  },
}
</script>

<style scoped>
.v-data-table {
  min-width: 100%;
}
/*v-chipも実体はspanなので適用される*/
a.disabled,
span.disabled {
  color: inherit;
  opacity: 0.25;
}
span.description {
  opacity: 0.5;
}
</style>
